import React from 'react';
import styled from 'styled-components';
import { IconButton, IconButtonProps } from '@material-ui/core';
import { KeyboardDatePicker, KeyboardDatePickerProps } from '@material-ui/pickers';

interface WrapperProps {
    dayIsBetween: boolean;
    isFirstDay: boolean;
    isLastDay: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
    ${({ theme, dayIsBetween, isFirstDay, isLastDay }) => `
        ${dayIsBetween
        ? `
            background: ${theme.palette.primary.main};
            color: ${theme.palette.common.white};
        ` : ``}
        ${isFirstDay
        ? `
            background: ${theme.palette.primary.main};
            color: ${theme.palette.common.white};
            border-top-left-radius: 50%;
            border-bottom-left-radius: 50%;
        ` : ``}
        ${isLastDay
        ? `
            background: ${theme.palette.primary.main};
            color: ${theme.palette.common.white};
            border-top-right-radius: 50%;
            border-bottom-right-radius: 50%;
        ` : ``}
    `}
`;

interface DayIconProps {
    nonCurrentMonthDay: boolean;
    highlightNonCurrentMonthDay: boolean;
}

export const DayIcon = styled(({ nonCurrentMonthDay, highlightNonCurrentMonthDay, ...props }: IconButtonProps & DayIconProps) => (
    <IconButton {...props} />
))`
    && {
        ${({ theme, nonCurrentMonthDay, highlightNonCurrentMonthDay }) => `
            ${nonCurrentMonthDay
        ? `
            color: ${theme.palette.text.disabled};
        `: ``}
        ${highlightNonCurrentMonthDay
        ? `
            color: #676767;
        `: ``}
            font-size: ${theme.typography.caption.fontSize};
        `}
        margin: 0 2px;
        color: inherit;
        width: 36px;
        height: 36px;
    }
`;

export type StyledKeyboardDatePickerProps = Omit<KeyboardDatePickerProps, 'InputProps'>;

export const StyledKeyboardDatePicker = styled((props: StyledKeyboardDatePickerProps) => (
    <KeyboardDatePicker
        InputProps={{
            disableUnderline: true
        }}
        {...props}
    />
))`
    .MuiOutlinedInput-input {
        padding: 11px;
    }
    .MuiIconButton-root {
        padding: 8.5px;
    }
    .MuiFormHelperText-root {
        position: absolute;
        bottom: -8px;
    }
`;